import { Chart as ChartJS, CategoryScale, LinearScale, TimeScale, PointElement, LineElement, BarElement, Title, Tooltip, Legend, Filler } from "chart.js";

// 필요한 스케일/요소/플러그인 등록
ChartJS.register(CategoryScale, LinearScale, TimeScale, PointElement, LineElement, BarElement, Title, Tooltip, Legend, Filler);

// 전역 옵션(선택)
ChartJS.defaults.responsive = true;
ChartJS.defaults.maintainAspectRatio = false;
